module.exports = __webpack_public_path__ + "img/sfbuy.edc8dca.webp";